import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'

const util = {
  cookies,
  db,
  log
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = process.env.VUE_APP_TITLE || 'D2Admin'
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

/**
 * @description 获取url中参数值
 * @param {String} serach 
 * @param {String} key 
 */
util.getUrlPara = function (serach, key) {
  var uri = serach;
  var re = new RegExp("" + key + "=([^&?]*)", "ig");
  return ((uri.match(re)) ? (uri.match(re)[0].substr(key.length + 1)) : null);
}

/**
 * 地址栏参数解析
 * 根据地址栏地址、或者指定的URL地址，进行参数解析
 * 默认获取当前访问页面URL解析
 */
util.getUrlParams = function (targetUrl) {
  var search = targetUrl ? targetUrl : window.location.href;
  var _urlArr = search.split("?");
  search = _urlArr && _urlArr.length > 1 ? '?' + _urlArr[1] : null;

  if (!search) {
    // 无参数
    return {};
  } else {
    var paramStr = search.substring(1);
    var arr = paramStr.split("&");
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
      var tmpArr = arr[i].split("=");
      obj[tmpArr[0]] = decodeURIComponent(tmpArr[1]);
    }
    return obj;
  }
}

util.setLoginByDingDing = function() {
  util.cookies.set('oauth_login_by_dingding', "1");
}

util.isLoginByDingDing = function() {
  let isByDD = util.cookies.get('oauth_login_by_dingding');
  return isByDD === "1";
}

export default util
